import { render, staticRenderFns } from "./WorkingAreaList.vue?vue&type=template&id=e644b220"
import script from "./WorkingAreaList.vue?vue&type=script&lang=js"
export * from "./WorkingAreaList.vue?vue&type=script&lang=js"
import style0 from "./WorkingAreaList.vue?vue&type=style&index=0&id=e644b220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports